// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.3.2@css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-2a3e639e]{padding:0 10px;cursor:pointer}li[data-v-2a3e639e]:hover{background:#f5f7fa}.is-select[data-v-2a3e639e]{color:#008dff;font-weight:800}.is-disabled-option[data-v-2a3e639e]{color:#c0c4cc;cursor:not-allowed}", ""]);
